module.exports = __webpack_public_path__ + "img/67.c8b18f20.jpg";